import cn from 'classnames'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'

import styles from './DashboardLabel.module.scss'

interface IDashboardLabelProps {
  translationKey: string
  replaceParams?: TReplaceOptions[]
  type?: 'title' | 'label' | 'subTitle'
}

export const DashboardLabel: FC<IDashboardLabelProps> = ({
  translationKey,
  replaceParams,
  type = 'label',
}) => {
  return (
    <div
      className={cn(styles.label, {
        [styles.title]: type === 'title',
        [styles.subTitle]: type === 'subTitle',
      })}
    >
      <Translation text={translationKey} replaceParams={replaceParams} />
    </div>
  )
}
